import React, { useCallback } from 'react'

import RichTextComponent from '../../../../sharedLegacy/components/RichTextComponent/RichTextComponent'
import { useVideoPreviewSettingsContext } from '../VideoPreviewSettingsContext'
import { useUpdateVideoDetailsMutation } from '../../../blocs/usePreviewVideoPage'

import { RichTextEditor } from './rich-text-editor/RichTextEditor'

import './VideoPreviewDescription.scss'

interface VideoPreviewDescriptionProps {
  content?: string
}

const VideoPreviewDescription = ({ content }: VideoPreviewDescriptionProps) => {
  const { bodyFont, bodyFontSize } = useVideoPreviewSettingsContext()
  const style = {
    fontFamily: bodyFont,
    fontSize: `${bodyFontSize}px`,
    lineHeight: '1.5',
  }

  return (
    <div style={style}>
      <RichTextComponent text={content ?? ''} />
    </div>
  )
}

interface EditableVideoPreviewDescriptionProps {
  videoId: number
  content?: string
}

const EditableVideoPreviewDescription = ({
  videoId,
  content,
}: EditableVideoPreviewDescriptionProps) => {
  const { mutateAsync: updateVideoDetails } = useUpdateVideoDetailsMutation()

  const handleDescriptionChange = useCallback(
    async (newContent: string) => {
      await updateVideoDetails({
        videoId,
        description: newContent,
      })
    },
    [updateVideoDetails, videoId]
  )

  const { bodyFont, bodyFontSize } = useVideoPreviewSettingsContext()
  const style = {
    fontFamily: bodyFont,
    fontSize: `${bodyFontSize}px`,
    lineHeight: '1.5',
  }

  return (
    <div className="video-preview-description-editable" style={style}>
      <RichTextEditor
        value={content ?? ''}
        onBlur={(value) => {
          void handleDescriptionChange(value)
        }}
        placeholder="Add video description here ..."
      />
    </div>
  )
}

interface VideoPreviewDescriptionDuplexerProps {
  videoId: number
  content?: string
  isEditable?: boolean
}

const VideoPreviewDescriptionDuplexer = ({
  videoId,
  content,
  isEditable = false,
}: VideoPreviewDescriptionDuplexerProps) => {
  return isEditable ? (
    <EditableVideoPreviewDescription videoId={videoId} content={content} />
  ) : (
    <VideoPreviewDescription content={content} />
  )
}

export { VideoPreviewDescriptionDuplexer as VideoPreviewDescription }
